<template>
  <div>
    <v-row justify="center">
      <v-col cols="4" md="auto" @click="showLMS_1 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lms-1.png" />
      </v-col>

      <v-col cols="4" md="auto" @click="showLMS_2 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lms-2.png"/>
      </v-col>

      <v-col cols="4" md="auto" @click="showLFO_1 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lfo-1.png"/>
      </v-col>

      <v-col cols="4" md="auto" @click="showLFO_2 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lfo-2.png"/>
      </v-col>

      <v-col cols="4" md="auto" @click="showLFO_3 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lfo-3.png"/>
      </v-col>

      <v-col cols="4" md="auto" @click="showLFO_4 = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/lfo-4.png"/>
      </v-col>

      <v-col cols="4" md="auto" @click="showMRF = true" class="cursor-pointer faixa">
        <Imagem src="modulo_02/mrf.png"/>
      </v-col>
    </v-row>

    <v-dialog v-model="showLMS_1" max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LMS-1 (Linha Branca Simples Contínua)</v-card-title>
        <v-card-text>
          Separa duas ou mais faixas do mesmo sentido e proíbe a ultrapassagem nesses trechos.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLMS_2" max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LMS-2 (Linha Branca Simples Seccionada)</v-card-title>
        <v-card-text>
          Permite a ultrapassagem nesses trechos.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLFO_1" max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LFO-1 (Linha Amarela Simples Contínua)</v-card-title>
        <v-card-text>
          Separa vias de sentidos opostos e proíbe a ultrapassagem nesses trechos.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLFO_2" max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LFO-2 (Linha Amarela Simples Seccionada)</v-card-title>
        <v-card-text>
          Permite a ultrapassagem nesses trechos.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLFO_3" max-width="500">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LFO-3 (Linha Amarela Dupla Contínua)</v-card-title>
        <v-card-text>
          Proíbe a ultrapassagem nos dois sentidos da via.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showLFO_4" max-width="540">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">LFO-4 (Linha Amarela Contínua / Seccionada)</v-card-title>
        <v-card-text>
          Somente é permitido ultrapassar no lado da via que a faixa é seccionada.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showMRF" max-width="600">
      <v-card class="rounded-lg">
        <v-card-title class="primary--text">MRF (Marcação de Faixa reversível no contra fluxo)</v-card-title>
        <v-card-text>
          Utilizada em lugares que possuem trânsito intenso em horários de pico.
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import Imagem from "@/components/Imagem.vue";

export default {
  components: {
    Imagem,
  },
  data() {
    return {
      showLMS_1: false,
      showLMS_2: false,
      showLFO_1: false,
      showLFO_2: false,
      showLFO_3: false,
      showLFO_4: false,
      showMRF: false,

    };
  },

  methods: {

  },
};
</script>

<style>
.faixa:hover {
  transition: all 0.3s ease;
  transform: scale(1.1);
  display: block;
}
</style>